import React from 'react';
import { Components } from './styled';

const ProjectDropdown = ({
  open,
  anchorEl,
  handleClose,
  children,
  dropdownInfo,
  onEdit,
  onDelete,
  onArchive,
  onDisable,
  onEnable,
  onViewDetails,
  onLogout,
  onRemove,
  onMoveUp,
  onMoveDown,
}: {
  open: boolean;
  anchorEl: HTMLElement | null;
  handleClose: () => void;
  children?: React.ReactNode;
  dropdownInfo?: string;
  onEdit?: () => void;
  onDelete?: () => void;
  onArchive?: () => void;
  onDisable?: () => void;
  onEnable?: () => void;
  onViewDetails?: () => void;
  onLogout?: () => void;
  onRemove?: () => void;
  onMoveUp?: () => void;
  onMoveDown?: () => void;
}) => {
  const _onDisable = () => {
    onDisable?.();
    handleClose();
  };

  const _onEnable = () => {
    onEnable?.();
    handleClose();
  };

  const _onEdit = () => {
    onEdit?.();
    handleClose();
  };

  const _onDelete = async () => {
    onDelete?.();
    handleClose();
  };

  const _onArchive = async () => {
    onArchive?.();
    handleClose();
  };

  const _onViewDetails = () => {
    onViewDetails?.();
    handleClose();
  };

  const _onLogout = () => {
    onLogout?.();
    handleClose();
  };

  const _onRemove = () => {
    onRemove?.();
    handleClose();
  };
  const _onMoveUp = () => {
    onMoveUp?.();
    handleClose();
  };
  const _onMoveDown = () => {
    onMoveDown?.();
    handleClose();
  };

  return (
    <Components.Menu
      elevation={0}
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'aria-labelledby': 'basic-button',
      }}>
      {dropdownInfo && dropdownInfo?.length > 0 && (
        <Components.InfoMenuItem disabled>{dropdownInfo}</Components.InfoMenuItem>
      )}
      {onViewDetails && <Components.MenuItem onClick={_onViewDetails}>View details</Components.MenuItem>}
      {onEdit && <Components.MenuItem onClick={_onEdit}>Edit</Components.MenuItem>}
      {onDisable && <Components.MenuItem onClick={_onDisable}>Disable</Components.MenuItem>}
      {onEnable && <Components.MenuItem onClick={_onEnable}>Enable</Components.MenuItem>}
      {onDelete && <Components.DestructiveMenuItem onClick={_onDelete}>Delete</Components.DestructiveMenuItem>}
      {onArchive && <Components.AlternativeMenuItem onClick={_onArchive}>Archive</Components.AlternativeMenuItem>}
      {onLogout && <Components.DestructiveMenuItem onClick={_onLogout}>Logout</Components.DestructiveMenuItem>}
      {onRemove && <Components.MenuItem onClick={_onRemove}>Remove</Components.MenuItem>}
      {onMoveUp && <Components.MenuItem onClick={_onMoveUp}>Move up</Components.MenuItem>}
      {onMoveDown && <Components.MenuItem onClick={_onMoveDown}>Move down</Components.MenuItem>}
      {children}
    </Components.Menu>
  );
};

export default ProjectDropdown;
